import React, { useEffect, useState } from "react";
import {
    Box,
    Text,
    TableBody,
    Table,
    TableCell,
    TableHeader,
    TableRow,
    Button,
} from "grommet";
import { getProductSkills } from "../../services/getProductSkills";

export const ProductsAssessment = ({
    user_id,
    assessment_id,
    onShowLearningPath,
    compact = false, // NEW
}) => {
    const [productsToWorkOn, setProductsToWorkOn] = useState([]);

    useEffect(() => {
        getProductSkills({ user_id, assessment_id })
            .then((response) => {
                setProductsToWorkOn(response.data.subProducts || []);
            })
            .catch((error) => {
                console.error("Error fetching products to work on:", error);
            });
    }, [user_id, assessment_id]);

    return (
        <Box direction="column" gap="small">
            <Text size="large" weight="bold" margin={{ bottom: "xsmall" }}>
                Skills assessed on
            </Text>

            {productsToWorkOn.length === 0 ? (
                <Text>
                    Based on the skills that you have selected and your responses, there
                    are currently no recommended courses. You can try a new self-
                    assessment with a new set of skills.
                    <br />
                    We recommend <b>HPE Digital Learner</b> to keep your skills refreshed
                    and learn further skills 24/7 x 365 days.
                </Text>
            ) : (
                // When compact, don't introduce any inner scrollbars
                <Box
                    overflow={compact ? "visible" : { horizontal: "auto" }}
                    height="auto"
                >
                    <Table fill style={{ tableLayout: "auto", width: "100%" }}>
                        <TableHeader>
                            <TableRow>
                                <TableCell scope="col">
                                    <Text weight="bold">Product name</Text>
                                </TableCell>
                                <TableCell scope="col">
                                    <Text weight="bold">Skill name</Text>
                                </TableCell>
                                <TableCell scope="col">
                                    <Text weight="bold">Course recommendation</Text>
                                </TableCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {productsToWorkOn.map((item) => (
                                <TableRow key={item.id}>
                                    <TableCell>
                                        <Text
                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                            title={item.product_name}
                                        >
                                            {item.product_name}
                                        </Text>
                                    </TableCell>
                                    <TableCell>
                                        <Text>{item.skill_name}</Text>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            primary
                                            label="View"
                                            onClick={() => onShowLearningPath(item.id)}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            )}
        </Box>
    );
};
